import React from "react";

export interface BaseAlertProps {
  type: "warn" | "error";
  children: React.ReactNode;
  title: string;
}

export const BaseAlert = ({ type, title, children }: BaseAlertProps) => {
  const colorClass = type === "warn" ? "text-[#E8BF1B]" : "text-[#DA3F3F]";
  const bgColorClass = type === "warn" ? "bg-[#E8BF1B]" : "bg-[#DA3F3F]";

  return (
    <div className="flex justify-center items-center md:p-0 w-full">
      <div className="flex flex-col justify-center items-center text-center gap-1 xl:gap-4 shadow-lg bg-white rounded-2xl xl:rounded-3xl mx-auto p-3 px-4 xl:p-6 w-full">
        {title && (
          <div
            className={`flex flex-col xl:flex-row gap-2 items-center text-2xl font-semibold ${colorClass}`}
          >
            <div className="relative inline-flex items-center justify-center">
              <div
                className={`absolute inset-0 ${bgColorClass} rounded-full z-10`}
              />
              <div
                className={`absolute inset-0 ${bgColorClass} rounded-full animate-pulse-scale`}
              />
              <div
                className={`${bgColorClass} h-9 xl:h-12 aspect-square p-2 rounded-full relative z-10 flex items-center justify-center`}
              >
                <img
                  src={
                    type === "warn"
                      ? "/dashboard/alert-icons/warn.svg"
                      : "/dashboard/alert-icons/error.svg"
                  }
                  className="h-full w-full object-contain"
                  alt={type === "warn" ? "Warning" : "Error"}
                />
              </div>
            </div>
            {title}
          </div>
        )}

        <div>{children}</div>
      </div>
    </div>
  );
};
